import Vue from 'vue'
import Vuex from 'vuex'

import router from '@/router'

// Make vue aware of Vuex
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    users: [
      {
        userId: 1,
        avatar: 'https://randomuser.me/api/portraits/men/85.jpg',
        fullname: 'Martin Müller',
        email: 'martin.mueller@oe1.de',
        role: 'user'
      },
      { divider: true,
        inset: true
      },
      { userId: 2,
        avatar: 'https://randomuser.me/api/portraits/women/85.jpg',
        fullname: 'Erika Musterfrau',
        email: 'jane.doe@oe1.de',
        role: 'user'
      },
      { divider: true,
        inset: true
      },
      { userId: 3,
        avatar: 'https://randomuser.me/api/portraits/women/86.jpg',
        fullname: 'Referatsleitung',
        email: 'referatsleitung@oe1.de',
        role: 'referatsleitung'
      }
    ],
    currentUser: {
      loggedIn: true,
      userId: 1,
      avatar: 'https://randomuser.me/api/portraits/men/85.jpg',
      fullname: 'Martin Müller',
      email: 'martin.mueller@oe1.de',
      role: 'user'
    },
    datasetsMeta: {
      sortIndicator: true,
      columnSorting: true,
      manualColumnResize: true,
      colWidths: 100,
      height: 600,
      contextMenu: true,
      rowHeaders: true,
      colHeaders: [
        'ID',
        'Quelle',
        'Name',
        'Beschreibung',
        'Erstellt am',
        'Zuletzt bearbeitet',
        'Sprache',
        'Kontakt',
        'Autor',
        'Status Erfassung',
        'Status Bewertung',
        'Status Aufwertung',
        'Status Anonymisierung',
        'Status Sichtbarkeit'
      ],
      data: [
        {
          id: '21e9ym28',
          source: '',
          name: 'Breitbandzugang nach Stadt',
          description: 'Anzahl der Haushalte mit Breitbandzugang, aufgeschlüsselt nach Stadt.',
          date: {
            created: '09.11.2017',
            modified: '09.01.2018'
          },
          language: 'Deutsch',
          contact: 'BMI',
          author: 'John Doe',
          status: {
            stepErfassung: true,
            stepBewertung: true,
            stepAufwertung: false,
            stepAnonymisierung: false,
            visibility: 'Unveröffentlicht'
          },
          bewertung: {
            maschinenlesbarkeit: '',
            auffindbarkeit: '',
            nutzungsbedingungen: '',
            verfuegbarkeit: '',
            offeneStandards: '',
            aktualisierungsrate: ''
          }
        },
        {
          id: 'xdq28pd',
          source: '',
          name: 'Studienerfolgsquote von Deutschen und Bildungsinländer/-innen',
          description: 'Studienerfolgsquote von Deutschen und Bildungsinländer/-innen in NRW und Deutschland in den Prüfungsjahren 2009 – 2014 nach Geschlecht und Beginn des Studiums',
          date: {
            created: '05.08.2017',
            modified: '08.08.2017'
          },
          language: 'Deutsch',
          contact: 'NRW',
          author: 'John Doe',
          status: {
            stepErfassung: false,
            stepBewertung: false,
            stepAufwertung: false,
            stepAnonymisierung: false,
            visibility: 'Unveröffentlicht'
          },
          bewertung: {
            maschinenlesbarkeit: '',
            auffindbarkeit: '',
            nutzungsbedingungen: '',
            verfuegbarkeit: '',
            offeneStandards: '',
            aktualisierungsrate: ''
          }
        },
        {
          id: 'h31r08s',
          source: 'BLE - EU-Agrarfonds',
          name: 'EU Farm subsidies for Germany in 2013',
          description: 'This dataset lists farm subsidy payments made in Germany as published directly by the government of Germany or sourced via freedom of information requests. Germany is 19th in our transparency index which measures how good governments are at opening up their data to the general public.',
          date: {
            created: '05.02.2013',
            modified: '01.03.2014'
          },
          language: 'English',
          contact: 'Bundesanstalt für Landwirtschaft und Ernährung',
          author: 'FarbSubsidy.org',
          status: {
            stepErfassung: true,
            stepBewertung: true,
            stepAufwertung: true,
            stepAnonymisierung: false,
            visibility: 'Unveröffentlicht'
          },
          bewertung: {
            maschinenlesbarkeit: '',
            auffindbarkeit: '',
            nutzungsbedingungen: '',
            verfuegbarkeit: '',
            offeneStandards: '',
            aktualisierungsrate: ''
          }
        }
      ]
    },
    datasets: [
      {
        id: 'peq2sad',
        stretchH: 'all',
        sortIndicator: true,
        columnSorting: true,
        contextMenu: true,
        rowHeaders: true,
        minRows: 10,
        manualColumnResize: true,
        colWidths: 100,
        colHeaders: [
          'ID',
          'Name',
          'Bezirk',
          'Datum',
          'Sicht',
          'Temperatur',
          'Profil',
          'RSS-Name',
          'BSL',
          'Algen',
          'Wasserqualität'
        ],
        data: [
          [
            '2',
            'Alter Hof',
            'Steglitz-Zehlendorf',
            '2017-09-12',
            '150',
            '18,10',
            'Unterhavel',
            'Alter Hof / Unterhavel',
            'B334',
            '1',
            '1'
          ],
          [
            '3',
            'Alter Hof',
            'Steglitz Zehlendorf',
            '2017-09-12',
            '150',
            '18,10',
            'Unterhavel',
            'Alter Hof/Unterhavel',
            'B334',
            '1',
            '1'
          ],
          [
            '4',
            'Bammelecke',
            'Treptow-Köpenick',
            '2017-09-05',
            '60',
            '20,10',
            'Dahme',
            'Bammelecke',
            'B225',
            '1',
            '1'
          ]
        ]
      },
      {
        id: 'xdq28pd',
        stretchH: 'all',
        sortIndicator: true,
        columnSorting: true,
        contextMenu: true,
        rowHeaders: true,
        manualColumnResize: true,
        colWidths: 100,
        height: 600,
        colHeaders: [
          'Prüfungsjahr',
          'Geschlecht',
          'Beginn des Studiums',
          'insgesamt',
          'Deutsche',
          'Bildungsinländer/-innen'
        ],
        data: [
          [
            '2013',
            'weiblich',
            '2002',
            '77,5',
            '78,1',
            '58,3'
          ],
          [
            '2013',
            'weiblich',
            '2003',
            '77,2',
            '77,9',
            '57,4'
          ],
          [
            '2013',
            'weiblich',
            '2004',
            '81,1',
            '81,7',
            '63,3'
          ],
          [
            '2013',
            'weiblich',
            '2005',
            '80,9',
            '81,6',
            '61,1'
          ],
          [
            '2014',
            'Insgesamt',
            '2002',
            '75,9',
            '76,5',
            '57,2'
          ],
          [
            '2014',
            'Insgesamt',
            '2003',
            '75,2',
            '75,9',
            '55,7'
          ],
          [
            '2014',
            'Insgesamt',
            '2004',
            '77,8',
            '78,5',
            '59,4'
          ],
          [
            '2014',
            'Insgesamt',
            '2005',
            '77,5',
            '78,1',
            '59,8'
          ],
          [
            '2014',
            'Insgesamt',
            '2006',
            '79,0',
            '79,6',
            '62,2'
          ],
          [
            '2014',
            'männlich',
            '2002',
            '74,4',
            '75,0',
            '56,4'
          ],
          [
            '2014',
            'männlich',
            '2003',
            '73,6',
            '74,2',
            '54,5'
          ],
          [
            '2014',
            'männlich',
            '2004',
            '74,8',
            '75,5',
            '55,9'
          ],
          [
            '2014',
            'männlich',
            '2005',
            '73,9',
            '74,4',
            '57,7'
          ],
          [
            '2014',
            'männlich',
            '2006',
            '74,5',
            '75,0',
            '59,5'
          ],
          [
            '2014',
            'weiblich',
            '2002',
            '77,3',
            '78,0',
            '58,1'
          ],
          [
            '2014',
            'weiblich',
            '2003',
            '77,0',
            '77,7',
            '56,9'
          ],
          [
            '2014',
            'weiblich',
            '2004',
            '81,0',
            '81,6',
            '63,5'
          ],
          [
            '2014',
            'weiblich',
            '2005',
            '81,1',
            '81,8',
            '62,0'
          ],
          [
            '2014',
            'weiblich',
            '2006',
            '83,6',
            '84,2',
            '65,4'
          ]
        ]
      },
      {
        id: 'h31r08s',
        stretchH: 'all',
        height: 900,
        sortIndicator: true,
        columnSorting: true,
        contextMenu: true,
        rowHeaders: true,
        manualColumnResize: true,
        colWidths: 100,
        colHeaders: [
          'Zahlungsempfänger',
          'Postleitzahl',
          'Ort',
          'Betrag in Euro',
          'Jahr',
          'Land'
        ],
        data: [
          [
            'Luettichauer Agrar GmbH',
            'DE-01561',
            'Thiendorf',
            '104927.92',
            '2013',
            'DE'
          ],
          [
            'MAP Meißener Agrarprodukte AG',
            'DE-01561',
            '',
            '259853.32',
            '2013',
            'DE'
          ],
          [
            'Priestewitzer Agrarprodukte GmbH',
            'DE-01561',
            'Priestewitz',
            '254537.21',
            '2013',
            'DE'
          ],
          [
            'Saechsische Milcherzeugergenossenschaft Quersa e.G.',
            'DE-01561',
            'Lampertswalde',
            '526617.05',
            '2013',
            'DE'
          ],
          [
            'Schweinemastbetrieb Bauda GmbH',
            'DE-01561',
            'Grossenhain',
            '138684.93',
            '2013',
            'DE'
          ],
          [
            'AG Uchtdorf e.G.',
            'DE-39517',
            '',
            '244264.6',
            '2013',
            'DE'
          ],
          [
            'AG Vietznitz eG',
            'DE-14662',
            '',
            '313159.52',
            '2013',
            'DE'
          ],
          [
            'AG Werenzhain eG',
            'DE-03253',
            '',
            '532058.22',
            '2013',
            'DE'
          ],
          [
            'AG Wörlitz eG',
            'DE-06785',
            '',
            '880158.03',
            '2013',
            'DE'
          ],
          [
            'Schulverband Hohenlockstedt',
            'DE-25551',
            'Hohenlockstedt',
            '118181.82',
            '2013',
            'DE'
          ],
          [
            'Amt Wilstermarsch',
            'DE-25554',
            '',
            '8525',
            '2013',
            'DE'
          ],
          [
            'Flurbereinigung Nortorf II Teilnehmergemeinschaft',
            'DE-25554',
            '',
            '124379.49',
            '2013',
            'DE'
          ],
          [
            'Gemeinde Hanerau-Hademarschen Amt Hanerau-Hademarschen',
            'DE-25557',
            '',
            '107000',
            '2013',
            'DE'
          ],
          [
            'Gemeinde Holstenniendorf',
            'DE-25560',
            'Schenefeld',
            '82944.54',
            '2013',
            'DE'
          ],
          [
            'Jan Rijpma GmbH',
            'DE-26736',
            '',
            '2466.45',
            '2013',
            'DE'
          ],
          [
            'Borkumer Weidegenoss. eG',
            'DE-26757',
            '',
            '30238.57',
            '2013',
            'DE'
          ],
          [
            'Reitanlage Jütting GmbH',
            'DE-26757',
            '',
            '516.95',
            '2013',
            'DE'
          ],
          [
            'Ev. ref. Kirchengemeinde Loppersum',
            'DE-26759',
            'Hinte',
            '85592',
            '2013',
            'DE'
          ],
          [
            'Landkreis Leer',
            'DE-26789',
            '',
            '108021.81',
            '2013',
            'DE'
          ],
          [
            'Leda-Jümme-Verband',
            'DE-26789',
            '',
            '1458.8',
            '2013',
            'DE'
          ]
        ]
      }
    ],
    currentDataset: {
      meta: {},
      dataset: {}
    },
    status: {
      demoUploadedFiles: false,
      loading: false,
      loadingDataset: false,
      finished: false,
      notifications: []
    }
  },
  actions: {
    // An action receives the commit from the components and
    // commits a new event to the mutations
    loadResource ({commit, state}, resourceIdentifier) {
      if (state.currentDataset.meta.id !== resourceIdentifier) commit('LOADRESOURCE', resourceIdentifier)
      // router.push('/erfassung/' + resourceIdentifier)
    },
    loginUser ({commit}, userId) {
      return new Promise((resolve, reject) => {
        commit('LOGINUSER', userId)
        resolve()
      })
    },
    logoutUser ({commit}) {
      commit('LOGOUTUSER')
      router.push('/login')
    },
    demoUploadDatasetMeta ({commit}) {
      return new Promise((resolve, reject) => {
        let demoDatesetMeta =
        {
          id: 'peq2sad',
          name: 'Liste der Berliner Badestellen',
          source: 'Landesamt für Gesundheit und Soziales',
          description: 'Landesamt für Gesundheit und Soziales',
          date: {
            created: '05.08.2017',
            modified: '08.08.2017'
          },
          language: 'Deutsch',
          contact: 'Landesamt für Gesundheit und Soziales',
          author: 'John Doe',
          status: {
            stepErfassung: true,
            stepBewertung: true,
            stepAufwertung: false,
            stepAnonymisierung: false,
            visibility: 'Unveröffentlicht'
          },
          bewertung: {
            maschinenlesbarkeit: '',
            auffindbarkeit: '',
            nutzungsbedingungen: '',
            verfuegbarkeit: '',
            offeneStandards: '',
            aktualisierungsrate: ''
          }
        }

        commit('DEMOUPLOADDATASETMETA', demoDatesetMeta)

        router.push('/erfassung/' + demoDatesetMeta.id)
        resolve(demoDatesetMeta)
      })
    },
    addNotification ({commit}, notificationContent) {
      commit('ADDNOTIFICATION', notificationContent)
    }
  },
  mutations: {
    // A mutation receives the current state as the first argument
    // You can make any modifications you want inside this function
    LOADRESOURCE (state, resourceIdentifier) {
      // Receives a resourceId, resourceName or resourceObject and loads requested resource
      state.status.loadingDataset = true
      state.currentDataset.meta = ''
      state.currentDataset.data = ''

      for (var i = state.datasetsMeta.data.length - 1; i >= 0; i--) {
        if (state.datasetsMeta.data[i].id === resourceIdentifier) {
          state.currentDataset.meta = state.datasetsMeta.data[i]
        }
      }

      state.currentDataset.dataset = ''
      for (var j = state.datasets.length - 1; j >= 0; j--) {
        if (state.datasets[j].id === resourceIdentifier) {
          state.currentDataset.dataset = state.datasets[j]
        }
      }
      setTimeout(function () { state.status.loadingDataset = false }, 600)
    },
    LOGINUSER (state, userId) {
      state.status.loading = true
      for (var i = state.users.length - 1; i >= 0; i--) {
        if (state.users[i].userId === userId) {
          state.currentUser = state.users[i]
        }
      }
      state.currentUser.loggedIn = true
      state.status.loading = false
    },
    LOGOUTUSER (state) {
      state.currentUser = {
        loggedIn: false
      }
    },
    DEMOUPLOADDATASETMETA (state, demoDatesetMeta) {
      state.datasetsMeta.data.push(demoDatesetMeta)
    },
    ADDNOTIFICATION (state, notificationContent) {
      state.status.notifications.push(notificationContent)
    }
  },
  getters: {
    getState: state => state,
    getUsers: state => state.users,
    getCurrentUser: state => state.currentUser,
    getDatasetsMeta: state => state.datasetsMeta,
    getCurrentDataset: state => state.currentDataset,
    getLoadingDatasetIndicator: state => state.status.loadingDataset,
    getIsReferatsleitung: state => {
      if (state.currentUser.role === 'referatsleitung') return true
      return false
    },
    getStatus: state => state.status,
    getNotifications: state => state.status.notifications
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js